'use strict';

const COOKIE_MAX_AGE = 10 * 365 * 24 * 60 * 60;

exports.COOKIE_MAX_AGE = COOKIE_MAX_AGE;
//# sourceMappingURL=consts.js.map
